export default {
  name: "Facebook",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  g: [
    {
      fill: "#1877f2",
      d:
        "M28 16a12 12 0 0 1-10.13 11.85v-8.38h2.8L21.2 16h-3.32v-2.25c0-.95.46-1.87 1.95-1.87h1.51V8.91s-1.37-.23-2.68-.23c-2.74 0-4.53 1.66-4.53 4.67V16h-3.05v3.47h3.04v8.38A12 12 0 1 1 28 16z",
    },
    {
      fill: "#fff",
      d:
        "M17.88 13.75V16h3.32l-.53 3.47h-2.8v8.38a12.07 12.07 0 0 1-3.75 0v-8.38h-3.04V16h3.04v-2.64c0-3.01 1.8-4.67 4.54-4.67 1.31 0 2.68.23 2.68.23v2.95h-1.5c-1.5 0-1.96.93-1.96 1.88z",
    },
  ],
}
